module.exports = __webpack_public_path__ + "images/sprites/ui/icon_ranking_silver_baabb60f94886cf33a330b04d4ab9cf5.png";